import { GameClient } from '../../gameClient/gameClient';
import {
    SetClientNotificationsBrowserStateHandler
} from '../../gameClient/clientCommands/SetClientNotificationsBrowserStateHandler';
import { NotificationsWrap } from '../../general/modules/notifications/NotificationsWrap';

export class GetNotificationsBrowserStateHandler {
    // eslint-disable-next-line class-methods-use-this
    public handle(): void {
        const isAccessBrowserNotifications: boolean = NotificationsWrap.hasBrowserGrantedPushes();
        console.log(`Notifications in browser: ${isAccessBrowserNotifications}`);
        GameClient.getInstance().sendCommand(new SetClientNotificationsBrowserStateHandler({
            // Если правильно помню, клиент ожидает стринговый бул
            isAccessBrowserPush: `${isAccessBrowserNotifications}`
        }));
    }
}
